import { Injectable } from '@angular/core';
import { HelpersService } from '../../core/helpers/helpers.service';
import { MovieItem } from './models/movie-item';
import { CategoryItem } from './models/category-item';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { MainboardItem } from './models/mainboard-item';
import * as is from 'is_js';
import { AuthKey } from '../auth-key.enum';
import { VodClientServicesService, ContentP, BookmarkP, LabelP, HomescreenVodsP, CategoryP, HomescreenVodsOpt } from '../cms-vod-client-api';
import { ClientServicesService } from '../360-client-api';
import { BaseDataService } from '../commons/base-data.service';
import { ContentExtended } from './models/contentExtended';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PosterCode } from '../enums/poster-code.enum';
import { ContentListResponse } from '../cms-vod-client-api/model/contentListResponses';

@Injectable()
export class VodDataRestService extends BaseDataService {
  private movieData: Array<MovieItem> = null;
  private categoryData: Array<CategoryItem> = null;
  private categoriesSubject;
  posterCode: number;
  mainboardPosterCode: number;

  constructor(private http: HttpClient,
    private restVod: VodClientServicesService,
    private restClient: ClientServicesService,
    private deviceDetector: DeviceDetectorService,
    helpers: HelpersService) {
    super(helpers);
    if (deviceDetector.isMobile()) {
      this.posterCode = PosterCode.mobileVer;
      this.mainboardPosterCode = PosterCode.mobileMain;
    }
    else if (deviceDetector.isTablet()) {
      this.posterCode = PosterCode.mobileVer;
      this.mainboardPosterCode = PosterCode.webMain;
    }
    else if (this.deviceDetector.isDesktop()) {
      this.posterCode = PosterCode.webVer;
      this.mainboardPosterCode = PosterCode.webMain;
    }
  }

  startVod(contentID: number): Observable<any> {
    return this.restVod.startVodUsingGET(contentID).map(response => {
      if (response.code == 200) {
        return response.data;
      }
      else {
        return false;
      }
    })
  }

  stopVod(contentID: number): Observable<any> {
    return this.restVod.stopVodUsingGET(contentID).map(response => {
      if (response.code == 200) {
        return response.data;
      }
      else {
        return false;
      }
    })
  }

  getContentsWithLabel(labelID: number): Observable<ContentP[]> {
    return this.restVod.getVodByLabelId(labelID, this.posterCode).map(response => {
      if (response.code === 200) {
        return response.data;
      } else {
        this.helpers.logger.error(response);
        // TODO popup error
        return null;
      }
    });
  }

  readonly productID = 1;
  getSingleContent(contentID: number | null): Observable<ContentP> {
    return this.restVod.getVod(contentID, "SPORTSTV-OTT-HLS").map(response => {
      if (response.code === 200) {
        const metadata = <MovieItem>response.data.metadata;
        metadata.external_id = response.data.id;
        return response.data;
      } else {
        this.helpers.logger.error(response);
        // TODO popup error
        return null;
      }
    });
  }

  getNextVod(contentID: number | null): Observable<ContentP> {
    return this.restVod.getNextVod(contentID).map(response => {
      if (response.code === 200) {
        return response.data;
      } else {
        this.helpers.logger.error(response);
        // TODO popup error
        return null;
      }
    });
  }

  getSingleContent2(contentID: number | null, dpName: string): Observable<ContentP> {
    return this.restClient.getVod(contentID, this.productID, dpName).map(response => {
      if (response.code === 200) {
        const metadata = <MovieItem>response.data.metadata;
        metadata.external_id = response.data.id;
        return response.data;
      } else {
        this.helpers.logger.error(response);
        // TODO popup error
        return null;
      }
    });
  }

  getThumbnails(url: string): Observable<any> {
    return this.http.get(url);
  }

  // getCategory(categoryID: string | null): Observable<CategoryItem> {
  //   return Observable.create((observer) => {
  //     this.getCategories().subscribe(categoryData => {
  //       const result = categoryData.find((itm) => itm.id.toString() === categoryID);
  //       observer.next(<CategoryItem>result);
  //       observer.complete();
  //     });
  //   });
  // }

  getAllMovies(): Observable<ContentP[]> {
    return this.restVod.getAllVods().map(response => {

      if (response.code === 200) {
        return response.data.map(itm => {
          itm.metadata.externalId = itm.id + '';
          return itm;
        });
      } else {
        this.helpers.logger.error(response);
        // TODO popup error
        return [];
      }
    });

  }

  cstID: number = -1;
  getHomeScreenVods(categoryId?: number): Observable<HomescreenVodsP[]> {
    return this.restVod.getHomescreenVodsWithQuery(this.cstID, this.posterCode, categoryId).map(response => {
      if (is.existy(response) && response.code === 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error(response.message);
        return null
          ;
      }
    })
  }


  getVodsForContentDetail(categoryID: number): Observable<HomescreenVodsOpt[]> {
    return this.restVod.getVodsForContentDetail(categoryID, this.posterCode).map(response => {
      if (is.existy(response) && response.code === 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error(response.message);
        return null
          ;
      }
    })
  }

  searchContents(searchQuery: string | null): Observable<ContentExtended[]> {
    searchQuery = searchQuery.toLocaleLowerCase();
    return this.restVod.searchUsingGET(searchQuery, this.posterCode).map(response => {
      if (is.existy(response) && response.code === 200) {
        return response.data;
      }
      else {
        return null;
      }
    })
    // if (is.empty(searchType)) {
    // this.getAllMovies().subscribe(movieData => {
    //   observer.next(<ContentP[]>filter(movieData));
    //   observer.complete();
    // });
    // } else {
    //   this.getContents(searchType).subscribe(movieData => {
    //     observer.next(<MovieItem[]>filter(movieData));
    //     observer.complete();
    //   });
    // }
  }

  getMainboardContents(mainboardID: number | null): Observable<MainboardItem[]> {
    return null;
    // return this.rest.getAllMainBoardItems(mainboardID).map(response => {
    //   if (response.code === 200) {
    //     return <MainboardItem[]>response.data.sort((a, b) => a.sequence - b.sequence);
    //   } else {
    //     this.helpers.logger.error(response);
    //     // TODO popup error
    //     return [];
    //   }
    // });

  }

  getMainContents(catID: number): Observable<ContentListResponse[]> {
      return this.restVod.getAllMainBoardItemsWithParam(this.mainboardPosterCode, catID ? catID : null,).map(response => {
        if (is.existy(response) && response.code === 200) {
          return response.data;
        }
        else {
          return null;
        }
      })
  }

  // getCategories(): Observable<CategoryItem[]> {
  //   if (this.categoryData) {
  //     const result = Observable.of(this.categoryData).delay(100);
  //     this.helpers.logger.info('return categoryData');
  //     return result;
  //   } else {
  //     if (!is.existy(this.categoriesSubject)) {
  //       this.categoriesSubject = Observable.create((observer) => {
  //         this.restVod.getLabels().subscribe(response => {
  //           if (response.code === 200) {
  //             this.categoryData = response.data.map(itm => <CategoryItem>{

  //               id: itm.id,
  //               title: itm.name,
  //               // children: [],
  //               // movies: []
  //             });
  //             observer.next(this.categoryData);
  //             observer.complete();
  //             this.categoriesSubject = null;
  //           }
  //         });
  //       });
  //     }
  //     return this.categoriesSubject;
  //   }

  // }

  getActiveCategories(): Observable<CategoryP[]> {
    return this.restVod.getActiveCategoriesUsingGET().map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error(response);
      }
    })
  }

  getRelatedContents(contentID: string): Observable<ContentListResponse[]> {
    return this.restVod.getRelatedContent(parseInt(contentID, 10), this.posterCode).map(response => {
      if (response.code === 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error(response);
        //TODO popup error
        return null;
      }
    });

  }

  getBookmark(contentId): Observable<any> {
    return this.restVod.getContentBookmark(JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY))).customerId, contentId).map(response => {
      if (is.existy(response) && response.code == 200) {
        if (response.data != null) {
          return response.data.time;
        }
        return null;
      }
      else {
        // this.helpers.alert.error("Bir hata oluştu")
      }
    })
  }

  setBookmark(contentId: number, bookmarkTime: number, duration) {
    if (JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY))) != null) {
      return this.restVod.setContentBookmark(JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY))).customerId, contentId, bookmarkTime, duration).map(response => {
        if (is.existy(response) && response.code == 200) {
          return response.data;
        }
        else {
          return null;
        }
      })
    }
    else {
      return
    }
  }

  getLastAddedContents(platform: string): Observable<ContentP[]> {
    return this.restVod.getLastAddedContents(platform).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data
      }
      else {
        // this.helpers.logger.error("last added data did not come");
        return null;
      }
    })
  }

  getCustomerBookmark(): Observable<BookmarkP[]> {
    return this.restVod.getcustomerbookmark(JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY))).customerId).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        // this.helpers.logger.error("customer bookmark gelmedi")
        return null;
      }
    })
  }

  getMostViewedContents(): Observable<ContentP[]> {
    return this.restVod.getMostViewedContents().map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        // this.helpers.alert.error("most viewed error");
        return null;
      }
    })
  }

  getContinueToWatchContents(): Observable<any> {
    return this.restVod.getContinueToWatchContents(JSON.parse((localStorage.getItem(AuthKey.LOGIN_KEY))).customerId).map(response => {
      if (is.existy(response) && response.code == 200) {
        // console.log("izlemeye decam: ", response.data)
        return response.data;
      }
      else {
        // this.helpers.logger.error("izlemeye devam et error");
        return null;
      }
    })
  }

  getChildVods(cid): Observable<ContentP[]> {
    return this.restVod.getChilds(cid, true, this.posterCode).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error("child content error");
        return null;
      }
    })
  }

  getAllLabels(): Observable<LabelP[]> {
    return this.restVod.getLabels().map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error("all labels error");
        return null;
      }
    })
  }

  getMenuLabels(categoryID: number): Observable<LabelP[]> {
    return this.restVod.getMenuLabels(categoryID).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error("menu labels error");
        return null;
      }
    })
  }

  getHomeScreenLabels(): Observable<LabelP[]> {
    return this.restVod.getHomeScreenLabels().map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        this.helpers.logger.error("home screen labels error");
        return null;
      }
    })
  }

  likeContent(contentID: number): Observable<any> {
    return this.restVod.likeContent(contentID).map(response => {
      if (response.code == 200) {
        return true;
      }
      else {
        return false;
      }
    })
  }

  disLikeContent(contentID: number): Observable<any> {
    return this.restVod.dislikeContent(contentID).map(response => {
      if (response.code == 200) {
        return true;
      }
      else {
        return false;
      }
    })
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/vod/vod-data-rest.service.ts